import React, { FunctionComponent } from 'react'
import styles from './Spinner.module.sass'

const Spinner: FunctionComponent = () => <div className={styles.spinner}/>

export default Spinner